import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";

@Component({
  selector: "transform-many-to-one",
  templateUrl: "./transform-many-to-one.component.html",
})
export class TransformManyToOneComponent implements OnInit {

  @Input() public fields: any[] = [];
  @Input() public switchs: any = {};
  @Output() public onCancel = new EventEmitter();
  @Output() public saveTransformation = new EventEmitter();

  public ngOnInit() {
    this.init();
  }

  public init(): void {
    if (this.switchs.lines && this.switchs.lines.length) {
      const lines = this.switchs.lines.filter((line) => line.end === this.switchs.item.field.end);
      if (this.switchs.item.field.targetFieldProperties && this.switchs.item.field.targetFieldProperties.sortByFields) {
        this.switchs.item.field.targetFieldProperties.sortByFields.forEach((i) => {
          const existline = lines.filter((line) => line.field.fieldKey === i.id);
          if (existline.length) {
            this.fields.push({
              lineId: existline[0].lineId,
              id: existline[0].field.fieldKey,
              name: existline[0].field.label,
              separator: i.separator,
              edit: false,
              uppercase: i.transformation === "uppercase",
              lowercase: i.transformation === "lowercase",
            });
          }
        });
      } else {
        lines.forEach((line) => {
          this.fields.push({
            lineId: line.lineId,
            id: line.field.fieldKey,
            name: line.field.label,
            separator: "",
            edit: false,
            uppercase: false,
            lowercase: false,
          });
        });
      }
    }
  }

  public drop(event: CdkDragDrop<any[]>) {
    const oldStructure = JSON.parse(JSON.stringify(this.fields));
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    this.fields.forEach((f, i) => {
      f.separator = oldStructure[i].separator;
    });

  }

  public uppercase(field) {
    field.uppercase = !field.uppercase;
    if (field.uppercase) {
      field.lowercase = false;
    }
  }

  public lowercase(field) {
    field.lowercase = !field.lowercase;
    if (field.lowercase) {
      field.uppercase = false;
    }
  }

  /*
  public save() {
    const transformations = { sortByFields: [] };
    this.fields.forEach((field, i) => {
      transformations.sortByFields.push({
        id: field.id,
        transformation: (!field.uppercase && !field.lowercase) ? "" : (field.uppercase ? "uppercase" : "lowercase"),
        separator: field.separator,
        order: i,
      });
    });
    this.saveTransformation.emit({data: transformations, switchs: this.switchs});
  }*/

}
